import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-menumaster-grid',
  templateUrl: './menumaster-grid.component.html',
  styleUrls: ['./menumaster-grid.component.scss']
})
export class MenumasterGridComponent implements OnInit {

 public moduleList: any[] = [];
  selectedModule = '';
  gridData: any[] = [];
  public gridData1: any[] = [];
public fullchecked:boolean=false;
toggleAllCheckboxes(){
  this.gridData.forEach(item => {
    item.isChecked = this.fullchecked;
  });
}
GetRights_list(){
  this.appservice.getTable("api/Transaction/pr_fetch_Rights").subscribe(
    (next: any) => {
      if (next && Array.isArray(next)) {
        this.moduleList = next;
      } else {
        this.moduleList = JSON.parse(next);
        console.error('Unexpected response format:', next);
      }
      
    },
    (error: any) => {
      console.log(error);
    }
  );  
}
loadMenubyModule(){
  if(!this.selectedModule) return;

  this.appservice.getMenuByModule(this.selectedModule)
    .subscribe(res => {
      this.gridData = res.map((x: any) => ({
        ...x,
        isChecked: false
      }));
    });
}
  GetmenuGrid(){
    this.appservice.getTable("api/Transaction/Get_Menu_Details?rights=" + this.appservice.Rights).subscribe(
      (next: any) => {
        this.gridData1 = next;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  constructor(public appservice: AppService) {
    this.load_Rightslist()
    this.GetmenuGrid();
  }
  // loadGrid() {
  //   if (!this.selectedModule) return;
  //   //this.GetmenuGrid();
    
  //   this.appservice.getMenuByModule(this.selectedModule)
  //     .subscribe(res => {
  //       this.gridData1 = res.map((x: any) => ({
  //         ...x,
  //         isChecked: true
  //       }));

  //     });
  //     //console.log("The grid data is",this.gridData1);
  //     this.gridData = this.gridData1;
  // }

  //  saveSelected() {
  //   const selectedRows = this.gridData.filter(x => x.isChecked);

  //   if (!selectedRows.length) {
  //     alert('Please select at least one row');
  //     return;
  //   }

  //   this.appservice.saveBulk(selectedRows)
  //     .subscribe(res => {
  //       if (res === 'True') {
  //         alert('Saved Successfully');
  //         this.loadGrid();
  //       } else {
  //         alert(res);
  //       }
  //     });
  // }
  loadGrid() {
    if (!this.selectedModule) return;
    //this.GetmenuGrid();
    
    this.appservice.getMenuByModule(this.selectedModule)
      .subscribe(res => {
        this.gridData1 =res;
        const a= res
        .map((x: any) => ({
          
          isChecked: x.MM_ID == x.MenuId?true:false
        }));
this.gridData = res;
this.gridData.forEach((item: any) => {
  item.isChecked = this.gridData1.find((x: any) => x.MM_ID === item.MM_ID)?.MM_ID === item.MenuId?true:false || item.MM_Route_Link === '#'?true:false;
});
console.log("The grid data is", this.gridData);
      //console.log("The grid data is",this.gridData1);
      //this.gridData = this.gridData1;
  });}
 load_Rightslist(){
    this.appservice.getTable("api/Transaction/Get_Rights_List?a="+"a").subscribe({
      next:(res:any)=>{       if(res){
        this.moduleList=res;
       }
      },
      error:(err:any)=>{
       //this.toastr.error(err,"Error");
      }
    })
  }
   saveSelected() {
     const selectedRows = this.gridData.filter((x: any) => x.isChecked);

  if (!selectedRows.length) {
    alert('Please select at least one row');
    return;
  }
  const payload = selectedRows.map((row: any) => ({
    RoleId: this.selectedModule,
    WEB_MM_ID: row.MM_ID,
    WEB_MM_Module: row.MM_Module,
    WEB_MM_Menu_Name: row.MM_Display_Name,
    WEB_MM_Display_Name: row.MM_Display_Name,
    WEB_MM_Menu_Order: row.MM_Order_No,
    WEB_MM_MenuLevel: row.MM_Menu_Level,
    WEB_MM_Icon: row.MM_Icon,
    WEB_MM_RouterLink: row.MM_Route_Link,
    isChecked: row.isChecked
  }));

  this.appservice.saveBulk(payload).subscribe(res => {
    if (res === 'True') {
      alert('Saved Successfully');
      this.loadGrid();
      this.gridData = [];
    } else {
      alert(res);
    }
  });
  }
  ngOnInit(): void {
    }}